import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Edit2 } from 'lucide-react'

const ExerciseList = ({ onBack, onEdit, currentUser }) => {
  const { t, i18n } = useTranslation()
  const [exercises, setExercises] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchExercises()
  }, [])
  const JP_TO_KEY = {
    '脚': 'legs', '腕': 'arms', '肩': 'shoulders', '背中': 'back', '胸': 'chest', '腹筋': 'abs', '有酸素運動': 'cardio'
  }
  const getBodyPartLabel = (jpName) => {
    const key = JP_TO_KEY[jpName]
    return key ? t(`body_parts.${key}`) : jpName
  }

  const canEdit = (exercise) => {
    if (!currentUser) return false
    // If exercise has no user_id (global), only admin can edit
    if (!exercise.user_id) return currentUser.admin
    // If exercise has user_id, only owner can edit
    return exercise.user_id === currentUser.id
  }

  const fetchExercises = async () => {
    try {
      const res = await fetch('/api/v1/exercises')
      if (res.ok) {
        const data = await res.json()
        setExercises(data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-[#111] text-white p-4 font-sans max-w-2xl mx-auto">
      <header className="flex items-center gap-4 mb-8 pt-4">
        <button
          onClick={onBack}
          className="p-2 hover:bg-white/10 rounded-full transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-2xl font-bold">{t('workout_list')}</h1>
      </header>

      {loading ? (
        <div className="text-center text-gray-500 mt-10">{t('loading')}</div>
      ) : (
        <div className="space-y-4">
          {exercises.map(exercise => (
            <div key={exercise.id} className="bg-[#1c1c1e] p-4 rounded-xl border border-gray-800 flex items-center gap-4">
              <div className="w-16 h-16 bg-[#2c2c2e] rounded-lg overflow-hidden flex-shrink-0 border border-gray-700">
                {exercise.image_url ? (
                  <img src={exercise.image_url} alt={exercise.name} className="w-full h-full object-cover" />
                ) : (
                  <img src="/no-image.png" alt="No Image" className="w-full h-full object-cover opacity-50" />
                )}
              </div>

              <div className="flex-1">
                <h3 className="font-bold text-lg">{(i18n.language === 'en' && exercise.en_name) ? exercise.en_name : (exercise.name || exercise.en_name)}</h3>
                <p className="text-gray-400 text-sm">{getBodyPartLabel(exercise.body_part) || t('unknown_part')}</p>
              </div>

              {/* Show edit button only if user owns the exercise or is admin and exercise is global */}
              {canEdit(exercise) && (
                <button
                  onClick={() => onEdit(exercise)}
                  className="p-2 bg-[#2c2c2e] hover:bg-[#3a3a3c] rounded-lg transition-colors text-gray-400 hover:text-white"
                >
                  <Edit2 className="w-5 h-5" />
                </button>
              )}
            </div>
          ))}

          {exercises.length === 0 && (
            <div className="text-center text-gray-500 py-10">
              {t('no_workouts_found')}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ExerciseList
